var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4721 3.52827C10.7324 3.78862 10.7324 4.21073 10.4721 4.47108L6.94346 7.99967L10.4721 11.5283C10.7324 11.7886 10.7324 12.2107 10.4721 12.4711C10.2117 12.7314 9.7896 12.7314 9.52925 12.4711L5.52925 8.47108C5.2689 8.21073 5.2689 7.78862 5.52925 7.52827L9.52925 3.52827C9.7896 3.26792 10.2117 3.26792 10.4721 3.52827Z",
    fill: "#2B1E70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavBackArrow);
export default __webpack_public_path__ + "static/media/navBackArrow.4027ec6bdef18853cbb6b36c95b402a2.svg";
export { ForwardRef as ReactComponent };